export default __webpack_public_path__ + "static/media/Vinay Aggarwal.91a70f95.jpg";